import React, { useEffect, useState } from 'react';
import qs from 'query-string';
import { useLocation, useNavigate } from '@reach/router';

import apiCall, { TEST_URL } from '~/utils/apiCall';
import dabangBridge from '~/utils/bridge';
import isEmpty from '~/utils/valid/is-empty';

import { Wrap, InfoText, ButtonWrap } from './styled';

function AzitTest() {
  const [authKey, setAuthKey] = useState('');
  const [platform, setPlatform] = useState('');
  const [appVersion, setAppVersion] = useState('');
  const [userInfo, setUserInfo] = useState({});
  const [isLoaded, setLoaded] = useState(false);

  const location = useLocation();
  const { pathname, search } = location;
  const parse = qs.parse(search);

  const navigate = useNavigate();

  useEffect(() => {
    setAuthKey(parse?.auth_key ?? '');
    setPlatform(parse?.platform ?? '');
    setAppVersion(parse?.version ?? '');
    navigate(pathname, { replace: true });
  }, []);

  useEffect(() => {
    if (authKey) getUserInfo();
  }, [authKey]);

  async function getUserInfo() {
    try {
      const res = await apiCall.get(`${TEST_URL}/api/v1/user`, { authKey });
      setUserInfo(res?.result ?? {});
      setLoaded(true);

    } catch(err) {
      console.log(err);
      setLoaded(false);
    }
  }

  function loginReload() {
    alert('로그인이 필요합니다.');

    dabangBridge.ios(call => {
      call.callHandler('ObjC Echo', {
        cmd: 'showLoginAndReload',
      });
    });

    dabangBridge.android(call => {
      call.showLoginAndReload();
    });
  }

  function authReload() {
    alert('본인인증이 필요합니다.');

    dabangBridge.ios(call => {
      call.callHandler('ObjC Echo', {
        cmd: 'showAuthAndReload',
      });
    });

    dabangBridge.android(call => {
      call.showAuthAndReload();
    });
  }

  function clickLinkToAzit() {
    if (isEmpty(userInfo)) return loginReload();
    if (!(userInfo?.safeAuth) && !(userInfo?.phone)) return authReload();

    dabangBridge.ios(call => {
      call.callHandler('ObjC Echo', {
        cmd: 'linkToAzit',
      });
    });

    dabangBridge.android(call => {
      call.linkToAzit();
    });
  }

  function clickShowCoinGuide() {
    dabangBridge.ios(call => {
      call.callHandler('ObjC Echo', {
        cmd: 'showCoinGuide',
      });
    });

    dabangBridge.android(call => {
      call.showCoinGuide();
    });
  }

  return (
    <Wrap>
      <div>
        <InfoText>
          <span className="bold">auth_key</span>
          <span className="value">{authKey || '없음'}</span>
        </InfoText>

        <InfoText>
          <span className="bold">platform</span>
          <span className="value">{platform || '없음'}</span>
        </InfoText>

        <InfoText>
          <span className="bold">version</span>
          <span className="value">{appVersion || '없음'}</span>
        </InfoText>
      </div>
  
      {isLoaded && (
        <div style={{ marginTop: 20 }}>
          {Object.entries(userInfo).map(v => {
            const name = v[0];
            const value = v[1];

            return (
              <InfoText key={name}>
                <span className="bold">{name}</span> <span className="value">{value+'' ?? '-'}</span>
              </InfoText>
            );
          })}
        </div>
      )}

      <ButtonWrap>
        <button onClick={clickLinkToAzit}>아지트 약관화면</button>
        <button onClick={clickShowCoinGuide}>다방코인 사용법</button>
      </ButtonWrap>
    </Wrap>
  );
}

export default AzitTest;
